import { useQueryParams } from '@shared/utils/hooks/useQueryParams';
import { getLocalStorage } from '@shared/core';

export const useRandomizedABTest = (testName: string) => {
  const queryParams = useQueryParams();
  const localStorage = getLocalStorage();
  const testStateKey = `joy_randomizedtest_${testName}`;

  const featureQueryString = queryParams[`feature_abtest_${testName}`];

  if (featureQueryString === '1') {
    return true;
  } else if (featureQueryString === '2') {
    return false;
  }

  const lastTestState = localStorage.getItem(testStateKey);

  if (lastTestState) {
    return lastTestState === 'true';
  }

  const randomBool = Math.random() < 0.5;

  localStorage.setItem(testStateKey, `${randomBool}`);

  return randomBool;
};
